import { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import TextReadMore from '../../../../TextReadMore';

const AgentPreferencesInfo = ({ isAgentPreferredHotel, informationAddedByAgent }) => {
  const { travelAgency = {} } = useSelector((store) => store.user);
  const agentPreferedHotelLabel =
    ((travelAgency || {}).settings || {}).agentPreferedHotelLabel ||
    'On your agency preferred list';
  const doHideAgentPreferedHotelLabel =
    travelAgency && travelAgency.settings && travelAgency.settings.hideAgentPreferedHotelLabel;

  return (
    isAgentPreferredHotel &&
    !doHideAgentPreferedHotelLabel && (
      <div className="text-sm w-full">
        {isAgentPreferredHotel && (
          <div className="bg-preferenceLabelColor bg-opacity-10 text-preferenceLabelColor-0 inline-block px-3 py-1 rounded-lg">
            <span>{agentPreferedHotelLabel}</span>
          </div>
        )}
        {informationAddedByAgent && <TextReadMore text={informationAddedByAgent} />}
      </div>
    )
  );
};

AgentPreferencesInfo.propTypes = {
  isAgentPreferredHotel: PropTypes.bool,
  informationAddedByAgent: PropTypes.string,
};

AgentPreferencesInfo.defaultProps = {
  isAgentPreferredHotel: false,
  informationAddedByAgent: '',
};

export default memo(AgentPreferencesInfo);
